export default {
	getReplysData(state) {
		
		let subscribeReplys = state.replys.filter(d=>d.type === 'subscribe')[0];
		let autoreplyReplys = state.replys.filter(d=>d.type === 'autoreply')[0];
		
		return {
			subscribeReplys,
			autoreplyReplys
		}
	}
	
}


// WEBPACK FOOTER //
// ./src/store/mp/wechat/replys/getters.js